import { createApi } from '@reduxjs/toolkit/query/react';

import { apiSettings } from '~constants/api';

import { Request, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import { LookupSetting } from '~main/models';

export const typePrefix = 'settings';

export const settingsApi = createApi({
  reducerPath: 'settingsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: `${apiSettings}/lookup` }),
  tagTypes: ['settings'],
  endpoints: (builder) => ({
    getSettings: builder.query<LookupSetting[], Request | void>({
      query: (params) => ({ url: '', method: 'GET', params }),
      providesTags: [{ type: 'settings', id: 'LIST' }],
      transformResponse: (payload) => unwrap<LookupSetting[]>(payload),
    }),
  }),
});

export const { useGetSettingsQuery } = settingsApi;
